import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';

// Column
import { BannerColumns, StaticRefresherColumns } from '../../appconfig/DatatableSetting';

// Data table
import { Skeletonitems, SkeletonbodyTemplate } from '../../appconfig/Settings';

//Services
import { getAllDetails, postAllData } from '../../service/ProductService';

// Api
import { GET_BANNER, UPDATE_BANNER } from '../../config/ApiConstant';
import { FrontWebsiteTabs } from './FrontWebsiteTab';
import { pdfTemplate } from '../../appconfig/DatatableTemplateSetting';

export const RefresherCourse = () => {
    document.title = 'Refresher Course | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [refresherCourseList, setRefresherCourseList] = useState<any>([]);
    const [editId, setEditId] = useState<any>(null);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [bannerDetails, setBannerDetails] = useState<any>({});

    // use effect method
    useEffect(() => {
        getAllRefresherCourseData();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get college list api call
    const getAllRefresherCourseData = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GET_BANNER);
            if (response) {
                const DataList: any = response;

                if (DataList.length === 0) {
                    setRefresherCourseList([]);
                } else {
                    let banner = [];
                    banner.push(DataList);
                    setRefresherCourseList(banner);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setRefresherCourseList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setRefresherCourseList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Template for action body
    const actionsTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions ">
                    <Button icon="pi pi-eye" tooltip="View" tooltipOptions={{ position: 'top' }} className="p-button-rounded mr-3" onClick={() => linkOpen(rowData?.refresher_schedule)} />

                    <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="p-button-rounded" onClick={() => openEditModal(rowData)} />
                </div>
            </>
        );
    };

    //Open Link in new tab
    const linkOpen = (file: any) => {
        window.open(file, '_blank');
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setBannerDetails({});
        setEditId(null);
        setSubmitLoading(false);
        setAddUpdateModal(false);
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setEditId(rowData);
        const fileName = rowData.refresher_schedule.split('/').pop();
        const fileType = `${fileName.split('.').pop()}`;
        // Create the desired object
        const FileObject = {
            url: rowData.refresher_schedule,
            name: fileName,
            type: fileType
        };
        setBannerDetails({
            banner_image: FileObject
        });
        setAddUpdateModal(true);
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'banner_image') {
            val = e.target.files[0] || '';
        } else {
            val = (e.target && e.target.value) || '';
        }
        setBannerDetails({ ...bannerDetails, [name]: val });
    };


    // On submit add update college
    const onSubmitAddUpdateCollege = async () => {
        try {
            setSubmitLoading(true);

            //Request object
            let formData: any = new FormData();
            formData.append('file', bannerDetails?.banner_image);

            //apicall
            const response = await postAllData(UPDATE_BANNER, formData);
            if (response && !window.cn(response)) {
                setEditId(null);
                setSubmitLoading(false);
                toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                closeAddUpdateModal();
                setTimeout(() => {
                    getAllRefresherCourseData();
                }, 1500);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast

                setSubmitLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Alert', detail: error.response.data.error || 'Something went wrong!' });
            }
        }
    };

    //delete selected file
    const onFileDelete = (name: string) => {
        setBannerDetails({ ...bannerDetails, [name]: '' });
    };

    const bannerTemplate = (rowData: any) => {
        return (
            <>
                <img className="banner-image" src={!window.cn(rowData?.banner_image) ? rowData?.banner_image : ''} alt="No Image" />
            </>
        );
    };

    return (
        <>
           <FrontWebsiteTabs mainTabLabel="Refresher Course" />
            <Toast ref={toast} />

            <div className="grid crud-demo mt-3">
                <div className="col-12">
                    <div className="card">
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={refresherCourseList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Banner Found"
                                    removableSort
                                >
                                    {StaticRefresherColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'refresher_schedule') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={pdfTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {StaticRefresherColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '600px' }}
                header="Update Banner"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" className="p-button-primary" icon="pi pi-check" onClick={() => onSubmitAddUpdateCollege()} loading={submitLoading} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12">
                        <label htmlFor="name">Add New PDF</label>
                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1rem', marginRight: '0.5rem' }}></i>
                            <span>Upload File</span>
                            <input type="file" id="fileInput" accept="application/pdf" onChange={(e) => onInputChange(e, 'banner_image')} className="file-input" />
                        </div>

                        {!window.cn(bannerDetails?.banner_image) && !window.cn(bannerDetails?.banner_image.size) ? (
                            <div className="file-preview">
                                <div className="file-info">
                                    <a href={URL.createObjectURL(bannerDetails?.banner_image)} target="_blank" rel="noopener noreferrer" className="file-name">
                                        {bannerDetails?.banner_image.name}
                                    </a>
                                    <span className="file-details">
                                        {bannerDetails?.banner_image.type} &nbsp;♦&nbsp; {(bannerDetails?.banner_image.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                            </div>
                        ) : !window.cn(bannerDetails) ? (
                            (!window.cn(bannerDetails?.banner_image) || bannerDetails?.banner_image?.name) && (
                                <>
                                    <div className="file-preview">
                                        <div className="file-info">
                                            <a href={!window.cn(bannerDetails?.banner_image) ? bannerDetails?.banner_image?.url : URL.createObjectURL(bannerDetails?.banner_image?.url)} target="_blank" rel="noopener noreferrer" className="file-name">
                                                {bannerDetails?.banner_image?.name}
                                            </a>
                                            <span className="file-details">
                                                {bannerDetails?.banner_image.type} &nbsp;&nbsp; {!window.cn(bannerDetails?.banner_image.size) && (bannerDetails?.banner_image.size / 1024).toFixed(2) + ' ' + 'KB'}
                                            </span>
                                        </div>
                                    </div>
                                </>
                            )
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </Dialog>
        </>
    );
};
